import { Category } from "../models/category.model";
import { BaseService } from "../../../../../core/services/base.service";

export class CategoryService {
    static async Get(): Promise<Category[]> {
        return await BaseService.Get("/public/jobs/categories");
    }
}